{
    "details": {
        "step": "Company details",
        "title": "Company details",
        "name": "Company name",
        "registration_number": "Company registration number",
        "registration_country": "Registration country code (two letters, e.g. DE)",
        "email": "Company email"
    },
    "primary_contact": {
        "primary_contact": "Primary contact",
        "first_name": "First name",
        "last_name": "Last name",
        "position": "Position",
        "email": "Email of primary contact",
        "phone": "Phone number of primary contact"
    },
    "address": {
        "address": "Address",
        "address_line": "Address line",
        "city": "City",
        "country": "Country code (two letters, e.g. DE)",
        "country_short": "Country",
        "zip": "ZIP"
    },
    "pin": {
        "title": "Setup finway PIN",
        "step": "Setup finway PIN",
        "create_prompt": "Please choose a corporate finway PIN",
        "create_success": "Corporate finway PIN successfully created",
        "corporate": "Corporate",
        "auth": "Finway PIN Authentication",
        "enter_prompt": "Please enter your finway PIN to continue. This is the PIN you created when you created your finway card account. If you forgot it, you can reset it in your profile settings."
    },
    "verification": {
        "email": {
            "step": "Verify email",
            "title": "Email verification",
            "prompt": "A verification code has been sent to your email address. Please enter it below and click next to continue.",
            "success": "Email successfully verified."
        },
        "mobile": {
            "step": "Verify mobile",
            "title": "Mobile verification",
            "prompt": "A verification code has been sent to your mobile number. Please enter it below and click next to continue.",
            "success": "Mobile number successfully verified."
        },
        "code": "Verification code",
        "resend_code": "Resend verification code",
        "code_sent": "Verification code has been sent."
    },
    "kyb": {
        "step": "KYB Form",
        "title": "KYB verification",
        "rejection_reason": {
            "ROOT_USER_MUST_BE_DIRECTOR_REPRESENTATIVE": "The person submitting the KYB request must be either a director or a legal representative of the company. Please have a director or legal representative of the company fill out the form.",
            "DOCUMENTS_UNSATISFACTORY": "The uploaded documents were rejected because they do not meet the requirements. Please check the documents you uploaded or contact our support at support@finway.de. We are pleased to help you.",
            "SUPPLIED_DATA_AND_DOCUMENTS_MISMATCH": "The filled-in information fields differ from the data in the uploaded documents. Please check and correct your data and the uploaded documents.",
            "LANGUAGE_IN_DOCUMENTS_UNSUPPORTED": "The language of the uploaded documents is not supported. Please upload the documents in German or English language or contact our support at support@finway.de. We are pleased to help you.",
            "SELFIE_UNSATISFACTORY": "The uploaded image of the person submitting the application was rejected. Please upload another image.",
            "SELFIE_AND_DOCUMENTS_MISMATCH": "The uploaded documents do not match with the picture of the person submitting the application. Please check the uploaded documents and information.",
            "CORPORATE_DETAILS_UNSATISFACTORY": "The information about the company has not been accepted. Please complete the company details.",
            "BENEFICIARY_DETAILS_UNSATISFACTORY": "The information about the beneficial owner(s) has not been accepted. Please complete the information about the person(s).",
            "REPRESENTATIVE_DETAILS_UNSATISFACTORY": "The information about the beneficial owner(s) has not been accepted. Please complete the information about the person(s).",
            "ROOT_USER_UNMATCHED_TO_DIRECTOR_OR_REPRESENTATIVE": "The information provided of the director or legal representative has not been accepted. Please complete the information about the person.",
            "OTHER": "The KYB process has been rejected. Please contact our support team at support@finway.de or get in touch with us via the chat at the bottom right. We would be pleased to help you."
        }
    },
    "business_account": {
        "title": "Business account creation",
        "step": "Business account",
        "success": "Business account successfully created.",
        "prompt": "In order to successfully conclude the KYB process, please create a business account that will be used for funding your cards by clicking the button below.",
        "enroll_admin_prompt": "Enroll all admins to the card program (this requires them to have a verified phone number)."
    },
    "company_position": {
        "director": "Director",
        "authorised_representative": "Authorized representative"
    },
    "create_account": "Create account",
    "industry_type": {
        "accounting": "Accounting",
        "audit": "Audit",
        "finance": "Finance",
        "public_sector_administration": "Public sector administration",
        "art_entertainment": "Art and entertainment",
        "auto_aviation": "Car and aviation",
        "banking_lending": "Banking and lending",
        "business_consultancy_legal": "Business consultancy and legal",
        "construction_repair": "Construction and repair",
        "education_professional_services": "Educational and professional services",
        "informational_technologies": "Informational technologies",
        "tobacco_alcohol": "Tobacco and alcohol",
        "gaming_gambling": "Gaming and gambling",
        "medical_services": "Medical services",
        "manufacturing": "Manufacturing",
        "precious_goods_jewelry": "Precious goods and jewelry",
        "non_governmental_organization": "Non governmental organization",
        "insurance_security": "Insurance and security",
        "retail_wholesale": "Retail and wholesale",
        "travel_tourism": "Travel and tourism",
        "freelancer": "Freelancer",
        "pr_marketing": "Public relations and marketing"
    },
    "source_of_funds": {
        "labour_contract": "Labour contract",
        "civil_contract": "Civil contract",
        "rent": "Rent",
        "funds_from_other_auxiliary_sources": "Funds from other auxiliary sources",
        "sale_of_movable_assets": "Sale of movable assets",
        "sale_of_real_estate": "Sale of real estate",
        "ordinary_business_activity": "Ordinary business activity",
        "dividends": "Dividends",
        "loan_from_financial_institutions_credit_unions": "Loan from financial institutions credit unions",
        "loan_from_third_parties": "Load from third parties",
        "sale_of_company_shares_business": "Sale of company shares business",
        "other": "Other",
        "specify_other": "Specify other"
    },
    "passcode": {
        "update": "Update finway PIN",
        "update_success": "Finway PIN update success",
        "enter_old_passcode": "Enter old finway PIN",
        "enter_new_passcode": "Enter new finway PIN"
    },
    "passcode_recovery": {
        "title": "Finway PIN recovery",
        "prompt": "We have sent you an email containing the verification code to reset your finway PIN. Please enter it in the field below.",
        "verification_code": "Verification code",
        "new_passcode": "New finway PIN",
        "enter_new_passcode": "Enter new finway PIN"
    }
}
